import React from 'react';
import { Button } from '@punchcard/core';

interface CategoryListProps {
  categories: Array<{ id: number; categoryName: string; symbols: SymbolDTO[] }>
  onCategorySelect: (categoryId: number) => void
  onClose: () => void
  currentCategoryName?: string
}

const SymbolModalCategoryList: React.FC<CategoryListProps> = ({ categories, onCategorySelect, onClose: _onClose, currentCategoryName }) => {
	const handleCategoryClick = (categoryId: number) => {
		onCategorySelect(categoryId);
	};
	return (
		<div className="symbols-modal__content">
			{categories.map((category) => {
				const isActive = category.categoryName === currentCategoryName;
				return (
					<Button
						key={category.id}
						className={`w-100 border-none text-start rounded-0  ${isActive ? 'btn-primary' : 'btn-ghost-primary'}`}
						onClick={() => handleCategoryClick(category.id)}
					>
						<div className="d-flex justify-content-between align-items-center">
							<span className="symbols-text">{category.categoryName}</span>
						</div>
					</Button>
				);
			})}
		</div>
	);
};

export default SymbolModalCategoryList;